// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"163d2804","239":"f3692751","453":"e942caeb","667":"b0ff626e"}[chunkId] + ".chunk.js";
};